
import { z } from 'zod';

export const DealerRatingSchema = z.object({
  rating: z.number().min(1, "La valutazione è obbligatoria (minimo 1 stella)").max(5),
  comment: z.string().max(500, "Il commento non può superare i 500 caratteri").optional().nullable(),
  dealer_id: z.string().uuid("ID dealer non valido"),
  user_id: z.string().uuid("ID utente non valido"),
});

export type DealerRatingFormValues = z.infer<typeof DealerRatingSchema>;
